import axiosClient from '../axiosClient';
import { SECTION_SCHEDULE_ENDPOINTS } from '../endpoints/sectionScheduler';

export const SectionSchedulerService = {
  async getSchedules(
    offset?: number,
    limit?: number,
    sort?: string[],
  ): Promise<IGetSchedulesResponse> {
    const params = new URLSearchParams();
    if (offset !== undefined) params.set('offset', String(offset));
    if (limit !== undefined) params.set('limit', String(limit));
    if (sort?.length) sort.forEach((s) => params.append('sort', s));
    const query = params.toString() ? `?${params}` : '';
    const res = await axiosClient.get<IGetSchedulesResponse>(
      `${SECTION_SCHEDULE_ENDPOINTS.GET_SCHEDULES}${query}`,
    );
    return res.data;
  },

  async getSchedule(id: number): Promise<IProductSectionScheduleResponse> {
    const res = await axiosClient.get<IProductSectionScheduleResponse>(
      SECTION_SCHEDULE_ENDPOINTS.GET_SCHEDULE(id),
    );
    return res.data;
  },

  async createSchedule(body: IScheduleSectionRequest): Promise<IProductSectionScheduleResponse> {
    const res = await axiosClient.post<IProductSectionScheduleResponse>(
      SECTION_SCHEDULE_ENDPOINTS.CREATE_SCHEDULE,
      body,
    );
    return res.data;
  },

  async updateSchedule(
    id: number,
    body: IScheduleSectionRequest,
  ): Promise<IProductSectionScheduleResponse> {
    const res = await axiosClient.put<IProductSectionScheduleResponse>(
      SECTION_SCHEDULE_ENDPOINTS.UPDATE_SCHEDULE(id),
      body,
    );
    return res.data;
  },

  async deleteSchedule(id: number): Promise<void> {
    await axiosClient.delete(SECTION_SCHEDULE_ENDPOINTS.DELETE_SCHEDULE(id));
  },

  async getAvailableSections(): Promise<IProductSectionSummary[]> {
    const res = await axiosClient.get<IProductSectionSummary[]>(
      SECTION_SCHEDULE_ENDPOINTS.GET_AVAILABLE_SECTIONS,
    );
    return res.data;
  },

  async forceExecute(id: number): Promise<IProductSectionScheduleResponse> {
    const res = await axiosClient.post<IProductSectionScheduleResponse>(
      SECTION_SCHEDULE_ENDPOINTS.FORCE_EXECUTE(id),
    );
    return res.data;
  },

  async forceTerminate(id: number): Promise<IProductSectionScheduleResponse> {
    const res = await axiosClient.post<IProductSectionScheduleResponse>(
      SECTION_SCHEDULE_ENDPOINTS.FORCE_TERMINATE(id),
    );
    return res.data;
  },
};
